var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialPinterest = function SvgSocialPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".social-pinterest_svg__st0,.social-pinterest_svg__st1{fill:#231f20}.social-pinterest_svg__st1,.social-pinterest_svg__st2{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-pinterest_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 43.3c-1.2 6-2.2 14-14.7 16.8 0 0-7.3 1.9-9.7-3.4-1.5 5.7-3 11-3.8 12.3-2 3.3-5.6 7.8-5.6 7.8s1.1-10.1 1.1-12.3c.1-3.4 3.4-19 3.4-19s-3.1-11 4.5-12.3c0 0 6.2-1.5 4.5 6.7 0 0-1.2 5.4-2.8 11.6l.5.8s1.5 3 4.5 3.4c3 .4 11.1-5.1 11.3-14.6.2-9.5-1.8-12.2-10.2-14.6-8.4-2.4-15.4 1.7-18.1 9-3 8.3-.5 10.3 1.1 12.3l-1 5.6s-8.1-2.7-7.9-11.2c.2-8.5 5.1-21.3 22.6-21.3C69 20.9 73.2 37.4 72 43.3z",
    id: "social-pinterest_svg__pinterest"
  }))));
};
export default SvgSocialPinterest;